"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UIControlledPopover = _interopRequireDefault(require("../../tooltip/UIControlledPopover"));

var _SimpleDateTypes = require("../../types/SimpleDateTypes");

var _createLazyPropType = _interopRequireDefault(require("../../utils/propTypes/createLazyPropType"));

var _CalendarFooterButtons = _interopRequireDefault(require("./CalendarFooterButtons"));

var _CalendarPage = _interopRequireDefault(require("./CalendarPage"));

var CalendarPagePopover = function CalendarPagePopover(props) {
  var calendarId = props.calendarId,
      clearLabel = props.clearLabel,
      max = props.max,
      maxValidationMessage = props.maxValidationMessage,
      min = props.min,
      minValidationMessage = props.minValidationMessage,
      onChange = props.onChange,
      today = props.today,
      todayLabel = props.todayLabel,
      children = props.children,
      id = props.id,
      onFocusLeave = props.onFocusLeave,
      onOpenChange = props.onOpenChange,
      open = props.open,
      rest = (0, _objectWithoutProperties2.default)(props, ["calendarId", "clearLabel", "max", "maxValidationMessage", "min", "minValidationMessage", "onChange", "today", "todayLabel", "children", "id", "onFocusLeave", "onOpenChange", "open"]);
  return _react.default.createElement(_UIControlledPopover.default, {
    arrowSize: "none",
    autoPlacement: "vert",
    content: {
      body: _react.default.createElement(_react.Fragment, null, _react.default.createElement(_CalendarPage.default, Object.assign({}, rest, {
        id: calendarId,
        max: max,
        maxValidationMessage: maxValidationMessage,
        min: min,
        minValidationMessage: minValidationMessage,
        onChange: onChange,
        tabIndex: -1,
        today: today
      })), _react.default.createElement(_CalendarFooterButtons.default, {
        clearLabel: clearLabel,
        max: max,
        maxValidationMessage: maxValidationMessage,
        min: min,
        minValidationMessage: minValidationMessage,
        onChange: onChange,
        today: today,
        todayLabel: todayLabel
      }))
    },
    onOpenChange: onOpenChange,
    pinToConstraint: ['left', 'right'],
    placement: "bottom right",
    id: id,
    onFocusLeave: onFocusLeave,
    open: open
  }, children);
};

if (process.env.NODE_ENV !== 'production') {
  CalendarPagePopover.propTypes = {
    calendarId: _propTypes.default.string.isRequired,
    calendarPage: _propTypes.default.shape({
      year: _propTypes.default.number.isRequired,
      month: _propTypes.default.number.isRequired
    }),
    children: _propTypes.default.node.isRequired,
    clearLabel: (0, _createLazyPropType.default)(_propTypes.default.string),
    max: _SimpleDateTypes.SimpleDateType,
    maxValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
    min: _SimpleDateTypes.SimpleDateType,
    minValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
    onCalendarPageChange: _propTypes.default.func.isRequired,
    onChange: _CalendarPage.default.propTypes.onChange,
    onFocusLeave: _UIControlledPopover.default.propTypes.onFocusLeave,
    onOpenChange: _propTypes.default.func.isRequired,
    open: _propTypes.default.bool.isRequired,
    today: _SimpleDateTypes.SimpleDateType.isRequired,
    todayLabel: (0, _createLazyPropType.default)(_propTypes.default.string),
    value: _CalendarPage.default.propTypes.value
  };
}

var _default = CalendarPagePopover;
exports.default = _default;
module.exports = exports.default;